<template>
    <div class="h-screen w-full flex flex-col items-center justify-center">
        <div class="md:border w-full max-w-md flex flex-col items-center px-12 py-14 rounded-3xl gap-6">
            <img src="@/assets/img/logo.png" @click="$router.push('/')" class="cursor-pointer w-min h-[3.5rem]" alt="">
            <span class="text-2xl text-center font-semibold tracking-wide">Check Your Inbox</span>
            <img src="@/assets/img/mail.png" class="h-52" alt="">
            <span class="text-sm font-medium tracking-wide leading-relaxed text-center text-secondary">A confirmation email to reset your password will be sent to your email address. Check your inbox or spam, then click the
                link to continue.</span>
            <span @click="$router.push('/SignIn')"
                class="text-primary cursor-pointer text-sm tracking-wide font-medium"
            >
                Back To Login
            </span>
        </div>

    </div>
</template>

<script>
export default {
    name: 'AuthenticationForgotNotif'
}
</script>